/**
 * <ResettableInput />
 *
 * A text input that has an 'X' that empties the field
 *
 * @parent anybody
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import './ResettableInput.scss';

class ResettableInput extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);

    this._onChange = this._onChange.bind(this);
    this._onReset = this._onReset.bind(this);

    this.state = {
      value: props.value || '',
    }
  }

  _onReset() {
    let {
      onReset
    } = this.props;

    if (typeof onReset == 'function') {
      onReset();
    } else {
      this.setState({
        value: '',
      });
    }

  }

  _onChange(e) {
    let {
      onChange
    } = this.props;

    if (typeof onChange == 'function') {
      onChange(e);
    } else {
      this.setState({
        value: e.target.value,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== undefined) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  render() {

    const {
      value,
    } = this.state;

    const {
      className,
      placeholder,
      hasMeaningfulValue,
      onFocus,
      isButton,
      isDropdown,
      onClick,
      disabled
    } = this.props;

    let hasValue;
    if (hasMeaningfulValue !== undefined) {
      hasValue = hasMeaningfulValue;
    } else {
      hasValue = value != '';
    }

    return (
      <div className={classnames(
          'resettable-input',
          className,
          {
            'has-value': hasValue,
            'is-button': isButton,
            'is-dropdown': isDropdown,
          }
        )} >
        <input
          placeholder={placeholder}
          value={value}
          className={classnames('form-control')}
          type='text'
          onFocus={onFocus}
          onClick={onClick}
          onChange={this._onChange}
          disabled={disabled}
        />
        { isDropdown &&
          <i onClick={onClick}></i>
        }
        { value !== "" && value !== undefined  &&
          <div className='reset-button' onClick={this._onReset}>x</div>
        }
      </div>
    )
  }
}

export default ResettableInput;



// WEBPACK FOOTER //
// ./src/components/UI/Inputs/ResettableInput.js